import React, {useState} from 'react';

interface MyComponentProps {
  text: string
}

export const Dictionary: React.FC<MyComponentProps> = ({text}) => {
  const [dictionary] = useState("logeion")

  return (
    <div>
      {(text && text.split(" ").length === 1) && 
      <div className="dict-container2" style={{"width": "99%", "height": "300px"}}>
        {
        dictionary === "logeion" ? <iframe width="100%"  height="100%" className="dict-iframe" title="logeion" src={"https://logeion.uchicago.edu/" + text }></iframe> 
        : 
        <iframe width="100%" height="500px" className="dict-iframe" title="whitakerswords" src={"http://archives.nd.edu/cgi-bin/wordz.pl?keyword=" + text }></iframe> 
        }
        </div>
      }
    </div>

    
  );
}
